import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { useStore } from '@/store';
import { getDeviceInfo, getNewClassReal, getDeviceTemper, getThreeTemper, getOpenCloseMechineMore } from '@/service/production/equipmentLive';
export default function useGuliaoList(params, threeTempeParams) {
  var store = useStore();
  var deviceInfo = ref({
    measure: '',
    rated_power: '',
    release_date: '',
    use: [],
    rated_current: '',
    weight: 0,
    draw: [],
    rated_voltage: '',
    pro_date: ''
  });
  var newClassReal = ref([]);
  var deviceTemper = ref([]);
  var threeTemper = ref([]);
  var openCloseList = ref([]);
  var getDeviceInfoAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getDeviceInfo(params.value);
          case 2:
            data = _context.sent;
            deviceInfo.value = data;
            store.commit('production/updateDrawList', data.draw);
            store.commit('production/updateUseList', data.use);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getDeviceInfoAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getNewClassRealAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getNewClassReal(params.value);
          case 2:
            data = _context2.sent;
            newClassReal.value = data.list[0].list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getNewClassRealAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getDeviceTemperAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getDeviceTemper(params.value);
          case 2:
            data = _context3.sent;
            deviceTemper.value = data.list;
            return _context3.abrupt("return", deviceTemper.value[0].machiVariable[0]);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getDeviceTemperAsync() {
      return _ref3.apply(this, arguments);
    };
  }();
  var getThreeTemperAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getThreeTemper(threeTempeParams.value);
          case 2:
            data = _context4.sent;
            threeTemper.value = data.list;
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getThreeTemperAsync() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getOpenCloseMechineMoreAsync = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getOpenCloseMechineMore(params.value);
          case 2:
            data = _context5.sent;
            openCloseList.value = data.list.map(function (item) {
              item.runTimeList = item.runTimeList.filter(function (iten) {
                return iten.value !== '0';
              });
              return item;
            });
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getOpenCloseMechineMoreAsync() {
      return _ref5.apply(this, arguments);
    };
  }();
  return [deviceInfo, newClassReal, deviceTemper, threeTemper, openCloseList, getDeviceInfoAsync, getNewClassRealAsync, getDeviceTemperAsync, getThreeTemperAsync, getOpenCloseMechineMoreAsync];
}